<script>
import {modalState, hideModal} from '@app/store/modalStore.svelte.js';
import {authState} from '@app/store/authStore.svelte.js';
import { projectState } from '@app/store/projectStore.svelte.js';
import { fade } from 'svelte/transition';
import * as m from "@app/paraglide/messages.js";

/* Firebase */
import db from '@app/configs/firestore.js';

let snapshots = $state([]);
let selectedSnapshot = $state();

let teamId = authState.team.id;
let dbSnapshotRef = db.collection("teams").doc(teamId).collection("projects").doc(projectState.teamId).collection("snapshots");
let dbCommitRef = db.collection("teams").doc(teamId).collection("projects").doc(projectState.teamId).collection("commits");
let gettingSnapshots = loadSnapshotHistory();

function loadSnapshotHistory(){
    snapshots = [];
    selectedSnapshot = undefined;
    return dbSnapshotRef.orderBy("createdOn", "desc").get().then(snapshotRes =>{
        snapshotRes.forEach(doc =>{
            console.log(doc.data());
            snapshots = [...snapshots, doc.data()];
        });
    });
}

async function deleteCommit(){
    try {
        await dbSnapshotRef.doc(selectedSnapshot.id).delete();

        await dbCommitRef.doc(selectedSnapshot.commit).delete();

        gettingSnapshots = loadSnapshotHistory();
    } catch(err){
        console.error(err);
        console.log(err.message);
    }    
}
</script>
  
  <div 
    transition:fade={{duration: 100}} 
    class="modal fade {modalState.selected === 'snapshotHistory' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="snapshotHistoryTitle"
    aria-describedby="snapshotHistoryDescription"
    tabindex="-1" 
    id="SnapshotHistoryModal"
>
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="snapshotHistoryTitle">{m.snapshot_history_title()}</h4>
          <button 
            type="button" 
            class="btn-close" 
            aria-label={m.snapshot_history_close_aria_label()} 
            id="closeSnapshotHistory"
            onclick={hideModal}
          ></button>
        </div>
        <div class="modal-body">
          <p id="snapshotHistoryDescription" class="visually-hidden">
            {m.snapshot_history_description()}
          </p>
          <div class="row">
            <div class="col-6">
                <button 
                  type="button" 
                  class="btn btn-light float-end mb-1" 
                  id="refreshSnapshots"
                  aria-label={m.snapshot_history_refresh_aria_label()} 
                  onclick={loadSnapshotHistory}
                ><i class="bi bi-arrow-clockwise" aria-hidden="true"></i></button>
                <select 
                  class="form-select form-select-sm" 
                  size="15" 
                  bind:value={selectedSnapshot}
                  aria-label={m.snapshot_history_select_aria_label()}
                  id="snapshotSelect"
                >
                    {#each snapshots as snapshot (snapshot.id)}
                        <option 
                          class="text-wrap {snapshot.status === 'in progress' ? 'text-danger' : ''}" 
                          value={snapshot}
                          aria-label={m.snapshot_history_commit_option_label({ user: snapshot.user, message: snapshot.message || m.snapshot_history_no_message() })}
                        >{snapshot.user} | {snapshot.message || m.snapshot_history_no_message()}</option>
                    {/each}
                </select>
            </div>
            <div class="col">
                <button 
                  type="button" 
                  class="btn btn-danger float-end mb-1" 
                  disabled={!selectedSnapshot || selectedSnapshot.id !== snapshots[0].id} 
                  onclick={deleteCommit}
                  id="deleteCommit"
                  aria-label={m.snapshot_history_delete_aria_label()}
                ><i class="bi bi-trash" aria-hidden="true"></i> {m.snapshot_history_delete_button()}</button>
                <table class="table table-light table-striped" aria-label={m.snapshot_history_details_aria_label()}>
                    <tbody>
                      <tr>
                        <th scope="row">{m.snapshot_history_id_label()}</th>
                        <td>{selectedSnapshot ? selectedSnapshot.commit  : ""}</td>
                      </tr>      
                      <tr>
                        <th scope="row">{m.snapshot_history_created_on_label()}</th>
                        <td>{selectedSnapshot ? selectedSnapshot.createdOn.toDate()  : ""}</td>
                      </tr>      
                      <tr>
                        <th scope="row">{m.snapshot_history_completed_label()}</th>
                        <td>
                          <i 
                            class="bi bi-{selectedSnapshot && selectedSnapshot.status === 'complete' ? 'check-lg' : 'slash-circle'}"
                            aria-label={selectedSnapshot && selectedSnapshot.status === 'complete' ? m.snapshot_history_completed_status() : m.snapshot_history_not_completed_status()}
                          ></i>
                        </td>
                      </tr>      
                      <tr>
                        <th scope="row">{m.snapshot_history_username_label()}</th>
                        <td>{selectedSnapshot ? selectedSnapshot.user  : ""}</td>
                      </tr> 
                      <tr>
                        <th scope="row">{m.snapshot_history_message_label()}</th>
                        <td>{selectedSnapshot && selectedSnapshot.message ? selectedSnapshot.message  : ""}</td>
                      </tr>                   
                    </tbody>
                  </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
            <button 
              type="button" 
              class="btn btn-light" 
              onclick={hideModal}
              id="closeModalBtn"
              aria-label={m.snapshot_history_close_aria_label()}
            >{m.snapshot_history_close_button()}</button>
        </div>
      </div>
    </div>
  </div>
